import styled from 'styled-components'
import ReactInputMask from 'react-input-mask'

export const LabelForgotPassword = styled.div`
  padding-left: 5px;
  color: #1E8B98;
  font-family: "Nunito";
  font-weight: bold;

  &.label-container {
    margin: 1rem;
    font-size: 14px;
  }
`

export const ForgotPasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const ContainerEmail = styled.div`
  display: flex;
  flex-direction:column;
  align-items: flex-start;
  width: 100%;

  &InputMask {
    width: 100%;
  }
`

export const InputEmail = styled(ReactInputMask)`
  border-radius:5px;
  border:2px solid #E0E0E0;
  height:49px;
  padding:0 15px;
  color:#000;
  font-size:18px;
  width: 100%;

  &:disabled{
    background:#E0E0E0;
  }
`

export const ButtonSend = styled.button`
  background:#00A3B4;
  color:#fff;
  border-radius:5px;
  padding:15px 0;
  font-size:17px;
  border:none;
  margin-top: 20px;
  width: 100%;

  &:disabled{
    background:#E0E0E0;
  }
`

export const SpanPasswordSent = styled.span`
  color: green;
  text-align: center;
  margin-top: 15px;
  font-weight: bold;
  width: 100%;
`
